import {createRoot} from 'react-dom/client';
import type {ReactElement} from 'react';

export function renderApp(element: ReactElement<any>, containerId: string): void {
  const a = document.createElement('div');
  a.setAttribute('id', containerId);
  document.body.appendChild(a);

  const container = document.getElementById(containerId);
  if (container) {
    const root = createRoot(container);
    root.render(element);
  } else {
    console.error(`Root element with ID '${containerId}' not found.`);
  }
}
